import { BehaviorSubject } from 'rxjs';
import { ITestRepetition } from '../../types';
import { IChangeBase, valueof } from '../change_base';
import { StreamBase } from '../stream_base';
import { TypeBase } from '../type_base';

export const SelectedRepetitionType: TypeBase = {
  average: 0,
  best: 1,
  single: 2,
};

export interface ISelectedRepetitionChange
  extends IChangeBase<valueof<TypeBase>, number | undefined> {
  type: valueof<typeof SelectedRepetitionType>;
  payload: number | undefined;
}

export class SelectedRepetitionChangeStream extends StreamBase<
  valueof<typeof SelectedRepetitionType>,
  number | undefined
> {
  public repetitions: ITestRepetition[] = [];
  public constructor(repetitions: ITestRepetition[]) {
    super(
      new BehaviorSubject<ISelectedRepetitionChange>({
        type: SelectedRepetitionType.average,
        payload: undefined,
      })
    );
    this.repetitions = repetitions;
  }

  public guard(): (change: ISelectedRepetitionChange) => boolean {
    return (change: ISelectedRepetitionChange): boolean => {
      switch (change.type) {
        case SelectedRepetitionType.single:
          return this.repetitions.length > 0 && change.payload !== undefined;
        case SelectedRepetitionType.best:
          return this.repetitions.length > 0 && change.payload !== undefined;
        case SelectedRepetitionType.average:
          return change.payload === 0;
        default:
          return false;
      }
    };
  }

  public select(rep: number): void {
    this.changes.next({
      type: SelectedRepetitionType.single,
      payload: rep,
    });
  }

  public selectAverage(): void {
    this.changes.next({
      type: SelectedRepetitionType.average,
      payload: 0,
    });
  }
}
